import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { ColorSwatch } from '@gik/ui/ColorSwatch/ColorSwatch';
import React from 'react';

export const thankYouBackgroundTypes: string[] = [
  'aqua',
  'grey',
  'yellow',
  'pink',
  'orange',
  'green',
  'blue',
  'purple',
];

export type ThankYouBackgroundPickerProps = {
  value?: string;
  onOpenChange?(value: boolean): void;
  onSelect?(colorName: string): void;
} & UIComponent;

function ThankYouBackgroundPickerComp({
  children,
  className,
  value = 'white',
  onOpenChange,
  onSelect,
  ...otherProps
}: React.PropsWithChildren<ThankYouBackgroundPickerProps>): React.ReactElement {
  const bem = useBemCN('thank-you-background-picker');

  const [_value, _setValue] = React.useState<string>(value);

  function handleSelect(colorName: string) {
    _setValue(colorName);
    onSelect(colorName);
  }

  return (
    <div {...bem(null, [], className)} {...otherProps}>
      <div {...bem('bg-picker')}>
        {thankYouBackgroundTypes.map(colorName => {
          return (
            <ColorSwatch
              key={colorName}
              className={`${colorName}-gradient`}
              onClick={() => handleSelect(colorName)}
              active={colorName === _value}
            />
          );
        })}
      </div>
    </div>
  );
}

export const ThankYouBackgroundPicker = withComponentErrorBoundary(ThankYouBackgroundPickerComp);
